import {Form, formsStore} from '../../../stores/Form';
import {getHTMLCellID} from './utils/getHTMLcellID';
import {isDevEnv} from '../../../utils/platform';

export const returnFocusToForm = (form?: Form) => {
    requestAnimationFrame(() => {
        let formActiveElement = formsStore.currentForm?.formActiveElement;
        const isActiveElementAttached = formActiveElement && document.contains(formActiveElement);

        if (!isActiveElementAttached && formsStore.currentForm) {
            // If no active element is found, we try to get the active cell based on the current form's state
            const activeCellID = getHTMLCellID(
                formsStore.currentForm,
                formsStore.currentForm.currentRow,
                formsStore.currentForm.currentColumn.index
            );
            const cellEl = document.querySelector(`#${activeCellID}`) as HTMLElement;
            formActiveElement = cellEl?.querySelector('input') as HTMLInputElement;

            isDevEnv() &&
                console.warn(
                    'No active form element to return focus to. Trying to set fallback focus.'
                );
        }

        if (formActiveElement) {
            formActiveElement.focus();
            isDevEnv() && console.log('Focus returned to form element:', formActiveElement);

            if (formActiveElement.tagName.toLowerCase() === 'input') {
                (formActiveElement as HTMLInputElement).select();
            }
        }
    });
};
